import React,{useContext} from "react";
import { Context } from '../../context/Context'

export default function WhoisitforCfd() {
  const {cfd} = useContext(Context)
  const {title3, description3} = cfd


  return (
    <>
      <section id="about" className="about-us ptb-100 ">
        <div className="container">
          <div className="row align-items-center justify-content-between">
          <div className="col-md-5">
              <div className="about-content-right">
                {cfd?.animations?.[1] && (
                    <video autoPlay loop muted playsInline style={{width: '100%'}}>
                      <source src={cfd.animations[1]} type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                )}
              </div>
            </div>
            <div className="col-lg-7">
              
              <h2>{title3} </h2>
          
              <ul className="list-unstyled">
                <li className="py-2">
                  <div className="d-flex align-items-center">
                
                    <div>
                      <p> <div dangerouslySetInnerHTML={{__html:description3}}/></p>
                    </div>
                  </div>
                </li>
             
              </ul>
              <br/>
          
            </div>
            
          </div>
        </div>
        
      
      </section>
    </>
  );
}
